type StateType = {
  stickyDistance: number
}

export default {
  namespaced: true,
  state: () => ({
    stickyDistance: undefined
  }),
  mutations: {
    setStickyDistance(state: StateType, stickyDistance: number) {
      state.stickyDistance = stickyDistance
    }
  },
  actions: {},
  getters: {}
}
